<div 
  class="zn-dropzone-container"
  [class.loading]="loading()">
  @if (!loading()) {
    <div
      class="zn-dropzone"
      [class.zn-drag-over]="isDragOver()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
      (click)="fileInput.click()"
      (keydown.enter)="fileInput.click()"
      (keydown.space)="fileInput.click(); $event.preventDefault()">
      <input
        type="file"
        hidden
        #fileInput
        id="zn-file-uploader"
        [accept]="acceptAttr()"
        [multiple]="multiple()"
        (change)="onFileSelected($event)"
      />
      <div class="zn-content">
          <i class="bi" 
            [class.bi-upload]="!isDragOver()" 
            [class.bi-download]="isDragOver()">
          </i>
          <label class="zn-title" for="zn-file-uploader">
            @if (!isDragOver()) {
              <strong>{{ primaryText()  | abpLocalization}}</strong>
              {{ secondaryText()  | abpLocalization}}
            } @else {
              <strong>{{ primaryText()  | abpLocalization}}</strong>
            }
          </label>
          <p class="zn-hint">
            {{localizationResource() + '::ZnFileUploaderAdmitedFormats' | abpLocalization}} {{ acceptText() }}<br />
            ({{localizationResource() + '::ZnFileUploaderMaxSize' | abpLocalization}} {{ maxSizeMb() }} MB)
          </p>
        </div>
    </div>
  }
  @if (file()) {
    <div class="zn-file-info">
      <i class="bi bi-file-earmark-text-fill"></i>
      @if (loading()) {
        <i class="spinner-border spinner-border-sm"></i>
      }
      <p class="name">{{ file()?.name }}</p>
      @if (!loading()) {
        <i class="bi bi-x-circle-fill close-icon" (click)="removeFile()" (keydown.enter)="removeFile()" (keydown.space)="removeFile(); $event.preventDefault()"></i>
      }
    </div>
  }
  @if (error()) {
    <zn-alert
      type="error"
      [title]="error()">
    </zn-alert>
  }
</div>